import React from "react";
import { motion } from "framer-motion";
import { Mail, MessageSquare } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

const COPY = {
  en: { overline: "Support", title: "Talk to the operations desk.", lead: "For any question about your Titan Units, statements, contracts or the operational status of the Batam site, use the channels below. Your dedicated account manager will respond within one business day.", emailTitle: "Investor relations", emailBody: "For contract, statement and general questions." },
  fr: { overline: "Support", title: "Parler au desk opérationnel.",  lead: "Pour toute question relative à vos Titan Units, vos relevés, vos contrats ou l'état opérationnel du site de Batam, utilisez les canaux ci-dessous. Votre gestionnaire dédié répond sous un jour ouvré.", emailTitle: "Relations investisseurs", emailBody: "Pour les questions contractuelles, relevés et générales." },
  es: { overline: "Soporte", title: "Habla con el equipo de operaciones.", lead: "Para cualquier pregunta sobre tus Titan Units, extractos, contratos o el estado operativo del sitio de Batam, utiliza los canales de abajo. Tu gestor dedicado responde en un día hábil.", emailTitle: "Relaciones con inversores", emailBody: "Para preguntas contractuales, extractos y generales." },
};

export default function Support() {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.en;

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
      <p className="overline text-muted-foreground">{c.overline}</p>
      <h1 className="mt-2 font-display text-3xl md:text-4xl font-light tracking-tighter">{c.title}</h1>
      <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-muted-foreground">{c.lead}</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
        <a
          href="mailto:contact@titan-infra.ai"
          data-testid="support-email"
          className="group block rounded-2xl border border-border bg-card p-6 hover:bg-secondary/30 transition-colors"
        >
          <Mail className="w-5 h-5 text-emerald-400" />
          <p className="mt-6 font-display text-xl tracking-tight">{c.emailTitle}</p>
          <p className="mt-2 text-[13px] leading-relaxed text-muted-foreground">{c.emailBody}</p>
          <p className="mt-5 text-[13px] font-mono text-foreground">contact@titan-infra.ai</p>
        </a>
        <div data-testid="support-chat" className="rounded-2xl border border-dashed border-border bg-transparent p-6">
          <MessageSquare className="w-5 h-5 text-muted-foreground" />
          <p className="mt-6 font-display text-xl tracking-tight text-muted-foreground">In-app messaging</p>
          <p className="mt-2 text-[13px] leading-relaxed text-muted-foreground">Coming soon.</p>
        </div>
      </div>
    </motion.div>
  );
}
